/**
 * The hall of fame's timetable, in ms from the moment the podium phase begins.
 *
 * Shared by the stage and the phones, which both start counting when they hear the
 * phase change: the stage reveals each place on this schedule, and a phone holds back
 * its owner's result until the stage has shown it — so the winner learns they won
 * with the room, not a few seconds before it from their pocket.
 */
export const PODIUM = {
  /** Third place lands. */
  third: 1_200,
  /** Second place lands. */
  second: 3_000,
  /** The empty top step starts to tremble: "and the winner is…". */
  drumroll: 4_400,
  /** First place lands, with the confetti. */
  first: 6_600,
  /** Everyone else's place: the runners-up on stage, and each phone's own result. */
  rest: 8_000,
} as const;

/** When a finishing position is revealed: its podium moment, or with everyone else. */
export function podiumRevealMs(rank: number | null): number {
  if (rank === 1) return PODIUM.first;
  if (rank === 2) return PODIUM.second;
  if (rank === 3) return PODIUM.third;
  return PODIUM.rest;
}
